import React from 'react'
import Navbar from './Components/Navbar/Navbar'
import Footer from './Components/Footer/Footer'
import Topbar from './Components/Topbar/Topbar'
import Body from './Components/Body/Body'
import Download from './Components/Pages/Download/Download'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Feedback from './Components/Pages/Feedback/Feedback'
import Careers from './Components/Pages/Careers/Careers'
import CSR from './Components/Pages/CSR/BloodDonationCamp'
import PhotoGalary from './Components/Pages/PhotoGallery/PhotoGallery'
import Infrastructure from './Components/Pages/Resources/Infrastructure/Infrastructure'
import Iso from './Components/Pages/Resources/IsoCertificate/ISOCertification'
import Quality from './Components/Pages/Resources/QualityPolicy/QualityPolicy'
import Safety from './Components/Pages/Resources/SafetyPolicy/SafetyPolicy'
import Sugar from './Components/Pages/ApplicationVideo/Sugar/Sugar'
import Contact from './Components/Pages/Contact/Contact'
import About from './Components/Pages/Corporate/About us2/Aboutus'
import Milestone from './Components/Pages/Corporate/Milestone/Milestone'
import Mission from './Components/Pages/Corporate/Mission/Mission'
import Steel from './Components/Pages/ApplicationVideo/Steel/Steel'
import Cement from './Components/Pages/ApplicationVideo/Cement/Cement'
import Chemical from './Components/Pages/ApplicationVideo/Chemical/Chemical'
import Product from './Components/Pages/Product/Product'
import Uncategory from './Components/Pages/Product/Uncategory/Uncategory'
import Automobile from './Components/Pages/Product/Automobile/Automobile'
import Boiler from './Components/Pages/Product/Boiler/Boiler'
import ProductCement from './Components/Pages/Product/ProductCement/ProductCement'
import ProductChemical from './Components/Pages/Product/ProductChemical/Pchemical'
import ProductOther from './Components/Pages/Product/ProductOther/Other'
import ProductPaper from './Components/Pages/Product/ProductPaper/Paper'
import ProductRefractory from './Components/Pages/Product/ProducRefractory/Refractory'
import ProductSolvent from './Components/Pages/Product/ProductSolvent/Solvent'
import ProductSteel from './Components/Pages/Product/ProductSteel/ProductSteel'
import ProductTransmission from './Components/Pages/Product/ProductTransmission/Transmission'
import ProductSugar from './Components/Pages/Product/ProductSugar/ProductSugar'
import Corporate from './Components/Pages/Corporate/About/About'
import Site from './Components/Pages/Sitemap/Sitemap'
import SiteBucket from './Components/Pages/Sitemap/Bucket Elevator Chain/BucketElevatorChain'
import SiteChemical from './Components/Pages/Sitemap/Chemical & fertilizer Conveyor Chain/ChemicalfertilizerConveyorChain'
import SiteCoke from './Components/Pages/Sitemap/Coke Oven Drag Chain/CokeOvenDragChain'
import SiteConveyor from './Components/Pages/Sitemap/Conveyor Chain/ConveyorChain'
import SiteDrag from './Components/Pages/Sitemap/Drag Flow Conveyor Chain/DragFlowConveyorChain'
import SiteHeavy from './Components/Pages/Sitemap/Heavy Duty Conveyor Chain/HeavyDutyConveyorChain'
import SitePalm from './Components/Pages/Sitemap/Palm & Soyabean Oil Conveyor Chain/PalmSoyabeanOilConveyorChain'
import SitePaper from './Components/Pages/Sitemap/Paper Industry Conveyor Chain/PaperIndustryConveyorChain'
import SitePower from './Components/Pages/Sitemap/Power Industry Chain/PowerIndustryChain'
import SiteScrapper from './Components/Pages/Sitemap/Scrapper Reclaimer Chain/ScrapperReclaimerChain'
import SiteSimplex from './Components/Pages/Sitemap/Simplex, Duplex, Triplex Transmission Chain/SimplexDuplexTriplexTransmissionChain'
import SiteSteel from './Components/Pages/Sitemap/Steel Industry Chain/SteelIndustryChain'

const App = () => {
  const router = createBrowserRouter([
    {
      path:"/",
      element: <>  <Navbar/> <Body/> <Topbar/><Footer/></>
    },
    {
      path:"/home",
      element: <>  <Navbar/> <Body/> <Topbar/><Footer/></>
    },
    {
      path:"/download",
      element: <>  <Navbar/><Topbar/> <Download/>  <Footer/></>
    },
    {
      path:"/about",
      element:<><Navbar/><Topbar/> <About/><Footer/></>
    },
    {
      path:'/feedback',
      element:<><Navbar/><Topbar/> <Feedback/><Footer/></>
    },
    {
      path:'/career',
      element:<><Navbar/><Topbar/> <Careers/><Footer/></>
    },
    {
      path:'/csr',
      element:<><Navbar/><Topbar/> <CSR/><Footer/></>
    },
    {
      path:'/photogalary',
      element:<><Navbar/><Topbar/> <PhotoGalary/><Footer/></>
    },
    {
      path:'/infrastructure',
      element:<><Navbar/><Topbar/> <Infrastructure/><Footer/></>
    },
    {
      path:'/isocertification',
      element:<><Navbar/><Topbar/> <Iso/><Footer/></>
    },
    {
      path:'/qualitypolicy',
      element:<><Navbar/><Topbar/> <Quality/><Footer/></>
    },
    {
      path:'/safetypolicy',
      element:<><Navbar/><Topbar/> <Safety/><Footer/></>
    },
    {
      path:'/sugar',
      element:<><Navbar/><Topbar/> <Sugar/><Footer/></>
    },
    
    {
      path:'/steel',
      element:<><Navbar/><Topbar/> <Steel/><Footer/></>
    },

    {
      path:'/cement',
      element:<><Navbar/><Topbar/> <Cement/><Footer/></>
    },
    
    {
      path:'/chemical',
      element:<><Navbar/><Topbar/> <Chemical/><Footer/></>
    },

    {
      path:'/contact',
      element:<><Navbar/><Topbar/> <Contact/><Footer/></>
    },
    {
      path:'/milestone',
      element:<><Navbar/><Topbar/> <Milestone/><Footer/></>
    },
    {
      path:'/mission',
      element:<><Navbar/><Topbar/> <Mission/><Footer/></>
    },
    {
      path:'/product',
      element:<><Navbar/><Topbar/> <Product/><Footer/></>
    },
    {
      path:'/corporate',
      element:<><Navbar/><Topbar/> <Corporate/><Footer/></>
    },
    {
      path:'/product-uncategory',
      element:<><Navbar/><Topbar/> <Uncategory/><Footer/></>
    },
    {
      path:'/product-automobile',
      element:<><Navbar/><Topbar/> <Automobile/><Footer/></>
    },
    {
      path:'/product-boiler',
      element:<><Navbar/><Topbar/> <Boiler/><Footer/></>
    },
    {
      path:'/product-cement',
      element:<><Navbar/><Topbar/> <ProductCement/><Footer/></>
    },
    {
      path:'/product-chemical',
      element:<><Navbar/><Topbar/> <ProductChemical/> <Footer/></>
    },
    {
      path:'/product-other',
      element:<><Navbar/><Topbar/> <ProductOther/> <Footer/></>
    },
    {
      path:'/product-paper',
      element:<><Navbar/><Topbar/> <ProductPaper/> <Footer/></>
    },
    {
      path:'/product-refractory',
      element:<><Navbar/><Topbar/> <ProductRefractory/> <Footer/></>
    },
    {
      path:'/product-solvent',
      element:<><Navbar/><Topbar/> <ProductSolvent/> <Footer/></>
    },
    {
      path:'/product-steel',
      element:<><Navbar/><Topbar/> <ProductSteel/> <Footer/></>
    },
    {
      path:'/product-transmission',
      element:<><Navbar/><Topbar/> <ProductTransmission/> <Footer/></>
    },
    {
      path:'/product-sugar',
      element:<><Navbar/><Topbar/> <ProductSugar/> <Footer/></>
    },
    {
      path:"/site",
      element:<><Navbar/><Topbar/> <Site/><Footer/></>
    },
    {
      path:"/site-bucket",
      element:<><Navbar/><Topbar/> <SiteBucket/><Footer/></>
    },
    {
      path:"/site-chemical",
      element:<><Navbar/><Topbar/> <SiteChemical/><Footer/></>
    },
    {
      path:"/site-Coke",
      element:<><Navbar/><Topbar/> <SiteCoke/><Footer/></>
    },
    {
      path:"/site-conveyor",
      element:<><Navbar/><Topbar/> <SiteConveyor/><Footer/></>
    },
    {
      path:"/site-drag",
      element:<><Navbar/><Topbar/> <SiteDrag/><Footer/></>
    },
    {
      path:"/site-heavy",
      element:<><Navbar/><Topbar/> <SiteHeavy/><Footer/></>
    },
    {
      path:"/site-palm",
      element:<><Navbar/><Topbar/> <SitePalm/><Footer/></>
    },
    {
      path:"/site-paper",
      element:<><Navbar/><Topbar/> <SitePaper/><Footer/></>
    },
    {
      path:"/site-power",
      element:<><Navbar/><Topbar/> <SitePower/><Footer/></>
    },
    {
      path:"/site-scrapper",
      element:<><Navbar/><Topbar/> <SiteScrapper/><Footer/></>
    },
    {
      path:"/site-simplex",
      element:<><Navbar/><Topbar/> <SiteSimplex/><Footer/></>
    },
    {
      path:"/site-steel",
      element:<><Navbar/><Topbar/> <SiteSteel/><Footer/></>
    },
])
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  )
}

export default App
